export class RequestError extends Error {
  constructor(props = { message: 'error', statusCode: 500, errorCode: 'ERROR' }) {
    const { message, statusCode, errorCode, ...extra } = props;
    super(message);
    this.statusCode = statusCode;
    this.errorCode = errorCode;
    this.extra = extra;
  }
}

export const processResponse = (response) => {
  if (response.status === 'OK') {
    return response.value;
  } else {
    throw new RequestError({ message: response.value, statusCode: 500, errorCode: 'ERROR' });
  }
};